var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgA1SocketCh(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M56.49 63h-37l-19-25 19-25h37l19 25-19 25zm-35-4h33l16-21-16-21h-33l-16 21 16 21zm29.26-30.5a4.5 4.5 0 11-4.5 4.5 4.49 4.49 0 014.5-4.5zM38 42a6 6 0 100 12 6 6 0 000-12zm0 8a2 2 0 110-4 2 2 0 010 4zm-8.25-17a4.5 4.5 0 11-4.5-4.5 4.49 4.49 0 014.5 4.5z",
    fill: "currentColor"
  })));
}
export default __webpack_public_path__ + "static/media/A1_Socket_CH.d104822f.svg";
export { SvgA1SocketCh as ReactComponent };